import { render, staticRenderFns } from "./breakdown.vue?vue&type=template&id=1129b07c&"
import script from "./breakdown.vue?vue&type=script&lang=js&"
export * from "./breakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports